import { ETSY, SHOPIFY } from '../../constants/channels';
import { DIGITAL } from '../../constants/attributes';
import { VALUE } from '../../constants/product';
import { FORM } from '../../constants/forms';

const { DETAILS, FILES, PERSONALIZATION, SHIPPING, VARIATIONS, SEO } = FORM;

export function shouldShowForm({ product, type }) {
  const channel = product.get('channel');

  switch (type) {
    case SHIPPING:
    case VARIATIONS: {
      return (
        channel !== ETSY ||
        !product.getIn([DETAILS, DIGITAL, VALUE])
      );
    }

    case FILES: {
      return !!product.getIn([DETAILS, DIGITAL, VALUE]);
    }

    case PERSONALIZATION: {
      return channel === ETSY;
    }

    case SEO: {
      return channel === SHOPIFY;
    }

    default: {
      return true;
    }
  }
}

export function shouldShowFormForProducts({ products, type }) {
  function reduceProducts(result, product) {
    return result || shouldShowForm({ product, type });
  }

  return products.reduce(reduceProducts, false);
}
